/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

import { cloneDeep } from 'lodash';

import { GeneralSection } from '../../general/index';

function handleTeamsData ({
  teamsGroup,
  contactsGroup = []
}) {
  const filteredTeams = teamsGroup.filter(group => {
    const hasTime = group.find(qst => qst.idQuestion === 2182 && (qst.answer || qst?.idPerson));
    return hasTime;
  });

  const noIdAnswerOption = {
    2184: 7797,
    2185: 7799,
    2186: 7801,
    2187: 7803,
    2188: 7805,
  };

  const teams = filteredTeams.map((group, index) => {
    const team = {
      idPerson: null,
      name: '',
      relationshipContent: {
        order: index + 1,
        type: null,
        mainGroups: []
      },
      contacts: []
    };
    
    for (const qst of group) {
      if (qst.idQuestion === 2182){
        team.name = qst.answer;
        team.idPerson = qst?.idPerson;
      } else if (qst.idQuestion === 2183) {
        team.relationshipContent.type = {
          answer: qst.answer,
          idAnswerOption: qst.idAnswerOption
        }
      } else if ([2184, 2185, 2186, 2187, 2188].includes(qst.idQuestion)) {
        const answerOption = qst.answerOptions.find(
          opt => opt.idAnswerOption === (qst?.idAnswerOption || noIdAnswerOption[qst.idQuestion])
        );

        team.relationshipContent.mainGroups.push({
          answer: answerOption.dsAnswerOption,
          idAnswerOption: answerOption.idAnswerOption,
          description: qst.dsQuestion
        });
      }
    }
    
    const contactsGroupTeam = contactsGroup.find(contactGroup => contactGroup.idPersonTeam === team.idPerson);

    if (contactsGroupTeam) {
      const contacts = contactsGroupTeam.contacts.filter(
        questions => questions.find(qst => qst.idQuestion === 2189)?.answer
      ).map(questions => {
        const contactName = questions.find(qst => qst.idQuestion === 2189);
        return {
          idPerson: JSON.parse(contactName.answer).id,
          idPersonRelationship: contactName?.idPersonRelationship
        };
      });

      team.contacts = contacts;
    }

    return team;
  });

  return teams;
}

function handleInitialAdjustments ({
  questionnaire,
  teams
}) {
  const [teamsGroupQst] = GeneralSection.events.groupMultipleFieldQuestions(
    2182,
    questionnaire
  );

  const teamsGroup = teams.map((team, index) => {
    const questions = cloneDeep(teamsGroupQst);
    
    let teamMainGroupTo = team?.relationshipContent?.mainGroups || [];
    teamMainGroupTo = teamMainGroupTo.map(value => (value.idAnswerOption));
    
    return questions.map(qst => {
      if (qst.idQuestion === 2182) {
        qst.answer = team.personFirstName;
        qst.idPerson = team.idPerson;
      } else if (qst.idQuestion === 2183 && team?.relationshipContent?.type) {
        const answerOption = qst.answerOptions.find(
          opt => opt.idAnswerOption === team.relationshipContent.type.idAnswerOption
        );
        qst.answer = answerOption?.dsAnswerOption;
        qst.idAnswerOption = answerOption?.idAnswerOption;
      } else if ([2184, 2185, 2186, 2187, 2188].includes(qst.idQuestion)) {
        const answerOption = qst.answerOptions.find(
          opt => teamMainGroupTo.includes(opt.idAnswerOption)
        );

        if (answerOption) {
          qst.answer = answerOption.dsAnswerOption;
          qst.idAnswerOption = answerOption.idAnswerOption;
        }
        
        if (index > 0) {
          qst.behaviorObject.extraDescriptionTop = '';
        }
      }
      return qst;
    });
  });
  
  return teamsGroup.length ? teamsGroup : [teamsGroupQst];
}

const events = {
  handleTeamsData,
  handleInitialAdjustments
};

export { events };